import React from 'react';

const PerfilContext = React.createContext();

export default PerfilContext;
